import { Option } from './Option';

export enum CreditUsageType {
    POWER_FLOW_SIMULATION = 'POWER_FLOW_SIMULATION',
    FAULT_SIMULATION = 'FAULT_SIMULATION',
    WIRE_SIZING_SIMULATION = 'WIRE_SIZING_SIMULATION',
    WORST_CASE_SIMULATION = 'WORST_CASE_SIMULATION',
    SUPPORT = 'SUPPORT',
    DIAGRAM_AI_MESSAGE = 'DIAGRAM_AI_MESSAGE',
    COMPONENT_INSTANCE_PLACEMENT = 'COMPONENT_INSTANCE_PLACEMENT',
    WIRE_SIZING = 'WIRE_SIZING',
}

export const CreditUsageTypeOptions: Option<CreditUsageType>[] = [
    { value: CreditUsageType.POWER_FLOW_SIMULATION, label: 'Power Flow Simulation' },
    { value: CreditUsageType.FAULT_SIMULATION, label: 'Fault Simulation' },
    { value: CreditUsageType.WIRE_SIZING_SIMULATION, label: 'Wire Sizing Simulation' },
    { value: CreditUsageType.WORST_CASE_SIMULATION, label: 'Automatic Connection Rating' },
    { value: CreditUsageType.SUPPORT, label: 'Support' },
    { value: CreditUsageType.DIAGRAM_AI_MESSAGE, label: 'AI Message' },
    { value: CreditUsageType.COMPONENT_INSTANCE_PLACEMENT, label: 'Component Instance Placement' },
    { value: CreditUsageType.WIRE_SIZING, label: 'Wire Sizing' },
];

export const CreditUsageTypeCosts: Record<CreditUsageType, number> = {
    [CreditUsageType.POWER_FLOW_SIMULATION]: 4,
    [CreditUsageType.FAULT_SIMULATION]: 4,
    [CreditUsageType.WIRE_SIZING_SIMULATION]: 4,
    [CreditUsageType.WORST_CASE_SIMULATION]: 4,
    [CreditUsageType.SUPPORT]: 1,
    [CreditUsageType.DIAGRAM_AI_MESSAGE]: 2,
    [CreditUsageType.COMPONENT_INSTANCE_PLACEMENT]: 1,
    [CreditUsageType.WIRE_SIZING]: 1,
};

// A fault simulation with min/max parameter scenarios solves three systems (min/nom/max)
// instead of one and is charged double. Scenarios are requested via the runMinMaxScenarios
// opt-in on the create form; estimate and reservation follow that flag, while the completed
// job is charged by what the engine result actually contains (safety net).
export const FAULT_SIMULATION_SCENARIO_MULTIPLIER = 2;

// A power flow is priced per island, so its CreditUsageTypeCosts entry is the price of a snapshot on one
// island. A batch on one island is priced by these row tiers instead, with the total rounded up to a whole
// credit.
export const POWER_FLOW_BATCH_TIERS = [
    { min: 1, max: 250, creditsPerRow: 2 },
    { min: 251, max: 10_000, creditsPerRow: 0.02 },
    { min: 10_001, max: Infinity, creditsPerRow: 0.01 },
] as const;

export const NEW_USER_CREDIT_AMOUNT = 100;
export const DEFAULT_CREDIT_AMOUNT = 100;
export const CREDIT_COST = 0.4;

export enum CreditGrantType {
    SIGN_UP = 'SIGN_UP',
    SUBSCRIPTION = 'SUBSCRIPTION',
    ONE_TIME = 'ONE_TIME',
}
